module.exports = __webpack_public_path__ + "img/3CX_advanced.d730d774.png";